import type { DivisionsListProps } from './divisions-list.interface';
import type { FC } from 'react';

import { useDispatch } from 'react-redux';
import { clearCurrentDivision } from 'store/divisions/divisions.slice';
import { clearSelectedPeople } from 'store/people/people.slice';

import { usePermissions } from '../../../contexts/permissions.context';
import { vocabulary } from '../../../vocabulary/german';
import { CreateButton } from '../../buttons/create-button/create-button';
import { EntityPanel } from '../../panels/entity-panel/entity-panel';
import { NotFoundMessage } from '../../template/not-found-message/not-found-message';

export const DivisionsList: FC<DivisionsListProps> = ({
  divisions,
  onSelect,
  onCreate,
  hideCreateButton,
  showDisabledItems,
  selectable,
}: DivisionsListProps) => {
  const matrix = usePermissions();
  const dispatch = useDispatch();
  const handleCreate = () => {
    dispatch(clearCurrentDivision());
    dispatch(clearSelectedPeople());
    onCreate();
  };

  const createDivisionBtn = (): JSX.Element | undefined => {
    if (matrix.permissions.createNew === true && !hideCreateButton) {
      return (
        <CreateButton
          text={vocabulary.buttons.createNewDivision}
          onClick={handleCreate}
        />
      );
    }
  };

  return divisions.length > 0 ? (
    <div className={'entities-list'}>
      {divisions.map((item, index) => (
        <EntityPanel
          isDisabled={showDisabledItems ? !!item.AgencyId : false}
          isSelectable={selectable}
          onClick={() => onSelect(item)}
          key={index}
          title={item.title}
          id={item.id}
        />
      ))}
      {createDivisionBtn()}
    </div>
  ) : (
    <>
      <NotFoundMessage
        message={`Nicht gefunden: Bereiche/Diensteinheiten konnten nicht gefunden werden.`}
      />
      {createDivisionBtn()}
    </>
  );
};
